import { Languages } from '@beable/content-types';
import {
  AcademicYearAvailabilityPayload,
  CourseAvailabilityType,
  CourseFrequencyType,
  DateAvailabilityPayload,
  MonthAvailabilityPayload,
  MonthlyFrequencyPayload,
  WeeklyFrequencyPayload
} from '@beable/roster-backend-client-v1';
import moment from 'moment';
import { DeliveryRules } from '../../services/CourseService';

export function useDeliveryStrings() {
    const getFrequencyString = (deliveryRules: DeliveryRules) => {
        switch (deliveryRules.frequencyType) {
            case CourseFrequencyType.Daily:
              return `Daily: Every ${deliveryRules.frequencyPayload?.interval} day(s)`;
            case CourseFrequencyType.Weekly:
              return `Weekly: Repeat every ${deliveryRules.frequencyPayload?.interval} week(s) on ${(deliveryRules.frequencyPayload as WeeklyFrequencyPayload)?.daysOfWeek}`;
            case CourseFrequencyType.Monthly:
              if ((deliveryRules.frequencyPayload as MonthlyFrequencyPayload)?.dayOfMonth) {
                return `Monthly: Day ${(deliveryRules.frequencyPayload as MonthlyFrequencyPayload)?.dayOfMonth} of every ${deliveryRules.frequencyPayload?.interval} month(s)`;
              } else {
                return `Monthly: First ${(deliveryRules.frequencyPayload as MonthlyFrequencyPayload)?.weekdayOfMonth} of every ${deliveryRules.frequencyPayload?.interval} month(s)`;
              }
        }
      }

      const getAvailabilityString = (deliveryRules: DeliveryRules) => {
        switch (deliveryRules?.availabilityType) {
          case CourseAvailabilityType.AcademicYear:
            return `AY Start to AY End, Backdate Type: ${(deliveryRules.availabilityPayload as AcademicYearAvailabilityPayload)?.backdateType}`;
          case CourseAvailabilityType.Custom:
            return `${moment((deliveryRules.availabilityPayload as DateAvailabilityPayload)?.startDate).format('YYYY-MM-DD')} -
            ${moment((deliveryRules.availabilityPayload as DateAvailabilityPayload)?.endDate).format('YYYY-MM-DD')}`;
          case CourseAvailabilityType.Month:
            return `Month of ${moment((deliveryRules.availabilityPayload as MonthAvailabilityPayload).month, 'M').format('MMMM')}`;
        }
      }

      const getLanguageString = (deliveryRules: DeliveryRules) => {
        switch (deliveryRules?.languageType) {
          case Languages.English:
            return `Course will be delivered only in English.`;
          case Languages.Spanish:
            return `Course will be delivered only in Spanish`;
        }
        return `Course will be delivered in all languages.`;
      }

      const getIgnoreSkipDatesString = (deliveryRules: DeliveryRules) => {
        if(deliveryRules.ignoreSkipDates) {
          return `Always deliver lessons (ignore closed dates)`;
        }
        return `Skip lesson delivery on closed dates`;
      }

      const getQuantityString = (deliveryRules: DeliveryRules) => {
        if(!deliveryRules.frequencyPayload || !deliveryRules.frequencyPayload?.quantityPerDate){
          return;
        }
        if(deliveryRules.frequencyType === CourseFrequencyType.Monthly) {
            return `${deliveryRules.frequencyPayload?.quantityPerDate} every month`;
        }
        return `${deliveryRules.frequencyPayload?.quantityPerDate} every day`;
      }


    return { getFrequencyString, getAvailabilityString, getQuantityString, getLanguageString, getIgnoreSkipDatesString };
}
